import { property } from '../LitElement/index.js';
import { bound, debounced } from '../decorators/index.js';

/**
 * isMobile mixin for lit-element based components.
 *
 * Set `isMobile` variable for further use by the component
 */
const isMobile =
  (breakpoint = 767) =>
  TargetClass =>
    class IsMobile extends TargetClass {
      /**
       * @type {boolean}
       */
      @property({ type: Boolean })
      accessor isMobile = IsMobile.isCurrentlyMobile();

      /**
       * Check if viewport is currently mobile
       * Viewport is considered mobile if it's inner width is less than provided breakpoint
       *
       * @returns {boolean}
       */
      static isCurrentlyMobile() {
        return window.innerWidth <= breakpoint;
      }

      /**
       * Event handler of `resize` window event
       * Check if viewport is mobile or desktop and appropriately set `isMobile` variable
       */
      @debounced(100)
      @bound
      resizeHandler() {
        const isCurrentlyMobile = IsMobile.isCurrentlyMobile();

        if (this.isMobile !== isCurrentlyMobile) {
          this.isMobile = isCurrentlyMobile;
          this.requestUpdate();
        }
      }

      /**
       * Lifecycle callback in the custom elements API
       * Fires each time a custom element is appended into a document-connected element
       *
       * Add event listener of `resize` window event
       */
      connectedCallback() {
        super.connectedCallback();
        window.addEventListener('resize', this.resizeHandler);
      }

      /**
       * Lifecycle callback in the custom elements API
       * Fires each time a custom element is removed from a document-connected element
       *
       * Remove event listener of `resize` window event
       */
      disconnectedCallback() {
        window.removeEventListener('resize', this.resizeHandler);
        super.disconnectedCallback();
      }
    };

export default isMobile;
